import { useState, useEffect } from 'react';
import { collection, query, where, orderBy, limit, onSnapshot } from 'firebase/firestore';
import { db, auth } from '../firebase';

export const useUnreadNotifications = () => {
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    const user = auth.currentUser;
    if (!user) return;

    // Simple query for viewer notifications
    const notificationsQuery = query(
      collection(db, 'notifications'),
      where('toUserId', '==', user.uid),
      where('isRead', '==', false),
      orderBy('createdAt', 'desc'),
      limit(100)
    );

    const unsubscribe = onSnapshot(notificationsQuery, (snapshot) => {
      const count = snapshot.size;
      setUnreadCount(count);
      console.log(`🔔 Unread notifications count updated: ${count}`);
    }, (error) => {
      console.error('Error fetching unread notifications:', error);
    });

    return () => unsubscribe();
  }, []);

  return unreadCount;
};
